import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import MetarDetailOutlook from './MetarDetailOutlook'
import MetarDetailWind from './MetarDetailWind'
import MetarDetailVisibility from './MetarDetailVisibility'
import MetarDetailWeather from './MetarDetailWeather'
import MetarDetailSky from './MetarDetailSky'
import MetarDetailTempDew from './MetarDetailTempDew'
import MetarDetailPressure from './MetarDetailPressure'
import MetarDetailRemarks from './MetarDetailRemarks'
import LoadingSplash from './LoadingSplash'
import Vector from './Vector'
import './styles/MetarDetail.css'
import classnames from 'classnames'
import * as action from '../actions/actions'
import { getStationName } from '../util/stations'
import AppHeader from './AppHeader'

class MetarDetail extends Component {

  componentDidMount() {
    const metar = this.props.metar
    if(!metar.updatedAt) {
      this.props.addAndUpdateEphemeralMetar(metar.icao, metar.name)
    }
  }
  render() {
    const metar = this.props.metar
    return (
      <div className={classnames('metarDetail', {
        darkBackground: true
      })}>
        <LoadingSplash
          title={"METAR"}
          isFetching={metar.isFetching}
          message={"Getting METAR data..."}
        >
          <AppHeader/>
          <div className="metarDetailBody">
            <div className={classnames("metarDetailHeader", {
              metarOutlookVFR: metar.flightRules === 'VFR',
              metarOutlookMVFR: metar.flightRules === 'MVFR',
              metarOutlookIFR: metar.flightRules === 'IFR',
              metarOutlookLIFR: metar.flightRules === 'LIFR'
            })}>
              <Vector
                distance={metar.distance}
                bearing={metar.bearing}
              />
              <div className="metarDetailStation">
                <div className="metarDetailStationCode displayValue">
                  {metar.icao}
                </div>
                <div className="metarDetailStationName subText">
                  {metar.name}
                </div>
              </div>
            </div>
            <MetarDetailOutlook
              flightRules={metar.flightRules}
              time={metar.time}
            />
            <MetarDetailWind
              windDirection={metar.windDirection}
              windVariableDirection={metar.windVariableDirection}
              windSpeed={metar.windSpeed}
              windGust={metar.windGust}
            />
            <MetarDetailVisibility
              visibility={metar.visibility}
            />
            <MetarDetailWeather
              weather={metar.weather}
            />
            <MetarDetailSky
              clouds={metar.clouds}
            />
            <div className="metarDetailTempDewPressureWrapper">
              <MetarDetailTempDew
                className="metarDetailSectionTempDew"
                temperature={metar.temperature}
                dewpoint={metar.dewpoint}
              />
              <MetarDetailPressure
                altimeter={metar.altimeter}
              />
            </div>
            <MetarDetailRemarks
              className="metarDetailSectionRemarks"
              remarks={metar.remarks}
            />
          </div>
        </LoadingSplash>
      </div>
    )
  }
}

const defaultMetarState = {
  altimeter: undefined,
  bearing: undefined,
  clouds: [],
  dewpoint: undefined,
  distance: undefined,
  error: undefined,
  flightRules: undefined,
  icao: undefined,
  isFetching: false,
  name: undefined,
  remarks: undefined,
  rawReport: undefined,
  temperature: undefined,
  time: undefined,
  updatedAt: undefined,
  visibility: undefined,
  windDirection: undefined,
  windGust: undefined,
  windSpeed: undefined,
  windVariableDirection: undefined
}

const mapStateToProps = (state, ownProps) => {
  const resolveMetarStateLocation = () => {
    var metar = state.metarLocation.metars.find(rec => {
      return rec.icao === ownProps.match.params.icao
    })
    if(!metar) {
      metar = state.ephemeralMetars.find(rec => {
        return rec.icao === ownProps.match.params.icao
      })
    }
    if(!metar) {
      metar = Object.assign({}, defaultMetarState, {
        icao: ownProps.match.params.icao,
        name: getStationName(ownProps.match.params.icao)
      })
    }
    return metar
  }

  return {
    metar: resolveMetarStateLocation()
    }
}

const mapDispatchToProps = dispatch => {
  return {
    addAndUpdateEphemeralMetar: (icao, name) => dispatch(action.addAndUpdateEphemeralMetar(icao, name)),
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps)(MetarDetail)
  )



// WEBPACK FOOTER //
// ./src/components/MetarDetail.js